import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { icoExpiredDuo, IconsModule } from '@platform-frontend/ui-tools';
import { CheckoutAssetModule } from './asset/checkout-asset.module';
import { CheckoutBillingInformationModule } from './billing-information/checkout-billing-information.module';
import { CheckoutCountryModule } from './country';
import { IsPaymentMethodOrBillingAddressDeletablePipe } from './is-payment-method-or-billing-address-deletable.pipe';
import { IsPaymentMethodOrBillingAddressEditablePipe } from './is-payment-method-or-billing-address-editable.pipe';
import { CheckoutPaymentInformationModule } from './payment-information/checkout-payment-information.module';
import { CheckoutPricingModule } from './pricing/checkout-pricing.module';
import { CheckoutProductModule } from './product/checkout-product.module';

@NgModule({
  declarations: [IsPaymentMethodOrBillingAddressDeletablePipe, IsPaymentMethodOrBillingAddressEditablePipe],
  imports: [
    CheckoutBillingInformationModule,
    CheckoutCountryModule,
    CheckoutPaymentInformationModule,
    CheckoutPricingModule,
    CheckoutProductModule,
    CheckoutAssetModule,
    CommonModule,
    IconsModule.withIcons(icoExpiredDuo)
  ],
  exports: [
    CheckoutBillingInformationModule,
    CheckoutCountryModule,
    CheckoutPaymentInformationModule,
    CheckoutPricingModule,
    CheckoutProductModule,
    CheckoutAssetModule,
    IsPaymentMethodOrBillingAddressDeletablePipe,
    IsPaymentMethodOrBillingAddressEditablePipe
  ]
})
export class CheckoutModule {}
